export class RqInputAddress {
    street: string | undefined;
    suburb: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    country: string | undefined;

    constructor(street: string | undefined, suburb: string | undefined, city: string | undefined,
                postCode: string | undefined, country: string | undefined) {
        this.street = street;
        this.suburb = suburb;
        this.city = city;
        this.postCode = postCode;
        this.country = country;
    }

    static empty(): RqInputAddress {
        return new RqInputAddress(undefined, undefined, undefined, undefined, undefined)
    }
}